<template>
        <div class="list_container">
            <div class="sea_bar cl">
                <div class="r">
                    <div class="l filter_item inpt">
                        <el-input placeholder="请输入角色名称搜索" icon="search" :on-icon-click="loadListData" v-model="filter.platRoleName" @keyup.enter.native="loadListData"></el-input>
                    </div>
                </div>
            </div>
            <div class="tools_bar">
                <el-button @click="handleNew">新增</el-button>
                <el-button @click="handleDelete">删除</el-button>
            </div>
            <div class="table_container">
                <el-table :data="list" @selection-change="listSelect" border>
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="角色名称">
                        <template scope="scope">
                            <a class="tabLink" @click="showConfigDia(scope.row)">{{scope.row.platrolename}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="platroledescr" label="备注"></el-table-column>
                </el-table>
                <div class="paging">
                    <el-pagination @current-change="handleCurrentPage" :current-page.sync="paging.currentPage" :page-size="paging.pageSize" layout="total, prev, pager, next" :total="paging.totalSize"></el-pagination>
                </div>
            </div>
            <el-dialog v-if="config.dia" v-model="config.dia" title="角色设置">
                <div class="dia_container role_setting">
                    <el-tabs v-model="config.active">
                        <el-tab-pane label="角色管理" name="first">
                            <div class="form_line cl">
                                <label class="l">角色名称：</label>
                                <div class="l inpt"><el-input v-model="config.platrolename"></el-input></div>
                            </div>
                            <div class="form_line cl">
                                <label class="l">角色类型<span class="red">*</span>：</label>
                                <div class="l sel">
                                    <el-select disabled v-model="config.platapplicationcode">
                                        <el-option label="IDE" value="1"></el-option>
                                        <el-option label="租户管理" value="2"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="form_line cl">
                                <label class="l">备注：</label>
                                <div class="l inpt"><el-input type="textarea" v-model="config.platroledescr"></el-input></div>
                            </div>
                            <div class="dia_btn_container">
                                <el-button @click="cancel()">关闭</el-button>
                                <el-button type="primary" @click="saveConfig">保存</el-button>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="platapplicationcode != '2'" :disabled="config.tabPaneDisabled.second" label="功能权限" name="second">
                            <el-tabs v-model="funTreeType">
                                <el-tab-pane label="IDE" name="ide">
                                    <el-tree 
                                    ref="funTree" 
                                    :props="funTreeProps" 
                                    :data="config.funTreeData" 
                                    node-key="id" 
                                    :default-checked-keys="config.checkedKeys"
                                    show-checkbox></el-tree>
                                </el-tab-pane>
                            </el-tabs>
                            <div class="dia_btn_container">
                                <el-button @click="cancel()">关闭</el-button>
                                <el-button type="primary" @click="saveGrantFun">保存</el-button>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :disabled="config.tabPaneDisabled.third" label="已分配人员" name="third">
                            <distributed :keyCode="curPlatRoleCode"></distributed>
                        </el-tab-pane>
                        <el-tab-pane :disabled="config.tabPaneDisabled.fourth" label="未分配人员" name="fourth">
                            <undistributed :keyCode="curPlatRoleCode"></undistributed>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-dialog>
        </div>
</template>
<script>
    import {API_ROOT} from '../../config/index'
    import distributed from './Distributed'
    import undistributed from './Undistributed'
    export default {
        props: ['platapplicationcode'],
        data: function(){
            return {
                openAccountSet: {
                    loading: false
                },
                list: [],
                paging: {
                    currentPage: 1,
                    pageSize: 15,
                    totalSize: 30
                },
                curPlatRoleCode: '',
                filter: {
                    userName: '',
                    contact: '',
                    status: '',
                    showChildren: ''
                },
                selection: [],
                config: {
                    dia: false,
                    active: 'first',
                    platrolename: '',
                    platroledescr: '',
                    platapplicationcode: '',
                    funTreeData: [],
                    checkedKeys: [],
                    tabPaneDisabled: {
                        second: false,
                        third: false,
                        fourth: false
                    }
                },
                funTreeProps: {
                    children: 'children',
                    label: 'name'
                },
                funTreeType: 'ide'
            }
        },
        components: {
            undistributed,
            distributed
        },
        created: function(){
             this.init()
        },
        methods: {
            // 初始化
            init(){
                this.loadListData()
            },
            // 新建
            handleNew() {
                this.curPlatRoleCode = ''
                this.resetConfigData()
                this.config.dia = true
            },
            // 重置角色编辑弹窗信息
            resetConfigData() {
                this.config.active = 'first'
                this.config.platrolename = ''
                this.config.platroledescr = ''
                this.config.platapplicationcode = this.platapplicationcode + ''
                this.config.funTreeData = []
                this.config.checkedKeys = []
                this.setConfigDisabled(true)
            },
            // 删除
            handleDelete() {
                if(this.selection.length === 0){
                    this.$message.warning('请选择角色！')
                    return
                }
                this.$confirm('确定删除角色？').then(() => {
                    let codeArr = []
                    this.selection.forEach(item => {
                        codeArr.push(item.platrolecode)
                    })
                    let param = {
                        platrolecodes: codeArr
                    }
                    this.postApi(`/platserv/role/delete`, param).then(() => {
                        this.$message.success('删除成功！')
                        this.loadListData()
                    }).catch(error => {
                        this.errorMessage(error)
                    })
                }).catch(() => {})
            },
            // 编辑弹窗
            showConfigDia(data) {
                this.resetConfigData()
                this.curPlatRoleCode = data.platrolecode
                this.config.platrolename = data.platrolename
                this.config.platroledescr = data.platroledescr
                this.config.platapplicationcode = data.platapplicationcode
                this.setConfigDisabled(false)
                this.getGrantFunctions()
                this.getRoleGrantFunctions()
                this.config.dia = true
            },
            // 设置编辑弹窗‘功能权限’、‘已分配人员’、‘未分配人员’是否禁止编辑
            setConfigDisabled(status){
                this.config.tabPaneDisabled.second = status
                this.config.tabPaneDisabled.third = status
                this.config.tabPaneDisabled.fourth = status
            },
            // 弹窗关闭
            cancel() {
                this.config.dia = false
            },
            // 编辑保存
            saveConfig() {
                let param = {
                    platrolecode: this.curPlatRoleCode ? this.curPlatRoleCode : '',
                    platrolename: this.config.platrolename,
                    platroledescr: this.config.platroledescr,
                    platapplicationcode: this.config.platapplicationcode
                }
                this.postApi(`/platserv/role/edit`, param).then(data => {
                    this.$message.success('保存成功！')
                    if(!this.curPlatRoleCode){
                        this.setConfigDisabled(false)
                        this.curPlatRoleCode = data
                        this.getGrantFunctions()
                    }
                    this.loadListData()
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 加载功能树
            getGrantFunctions() {
                // 租户管理暂时没有功能权限设置
                if(this.platapplicationcode != '2'){
                    this.postApi(`/platserv/role/getGrantFunctions`,{
                        appid: '1'  // 1-ide,2-web
                    }).then(data => {
                        this.config.funTreeData = data
                    }).catch(error => {
                        this.errorMessage(error)
                    })
                }
            },
            // 加载已设置功能权限信息
            getRoleGrantFunctions(){
                this.postApi(`/platserv/role/getRoleInfo`,{
                    platrolecode: this.curPlatRoleCode
                }).then(data => {
                    this.config.checkedKeys = data.platRoleFunctions
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 选择租户
            listSelect(data) {
                this.selection = data
            },
            // 功能权限保存
            saveGrantFun() {
                let selectedNodes = this.$refs['funTree'].getCheckedNodes()
                let codes = []
                selectedNodes.forEach(function(item){
                    codes.push(item.id)
                })
                this.postApi(`/platserv/role/editGrantFunctions`, {
                    platrolecode: this.curPlatRoleCode,
                    functioncodes: codes
                }).then(() => {
                    this.$message.success('保存成功！')
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 加载列表数据
            loadListData() {
                this.$http.post(`/platserv/role/list`,{
                    page: this.paging.currentPage,
                    rows: this.paging.pageSize,
                    platrolename: this.filter.platRoleName,
                    platapplicationcode: this.platapplicationcode
                }).then(function(res){
                    this.list = res.data.resp_data.data
                    this.paging.totalSize = res.data.resp_data.resultCount
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 编辑接口
            postApi(url, param) {
                return new Promise((resolve,reject) => {
                    this.$http.post(url, param).then(function(res){
                        resolve(res.data.resp_data)
                    }).catch(function(error){
                        reject(error)
                    })
                })
            },
            // 页码切换
            handleCurrentPage(val) {
                this.paging.currentPage = val
                this.loadListData()
            },
            // 显示错误消息
            errorMessage(error) {
                let msg = (error.body && error.body.error_code) || error.statusText || error
                this.$message.error(msg)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// list.vue?73ffc726